if (!customElements.get('halloween-sale-filter')) {
  customElements.define('halloween-sale-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.events = new AbortController();
      const listen = (target, type, handler, options = {}) => target.addEventListener(type, handler, {
        ...(typeof options === 'boolean' ? { capture: options } : options), signal: this.events.signal
      });
      const sectionSel = '#shopify-section-' + this.dataset.sectionId;
      const rowSelector = sectionSel + ' [data-tabs-level="sub"] .filter-values-row-inner';
      const root = this;
      const topButtons = [...this.querySelectorAll('[data-tabs-level="top"] button[role="tab"]')];
      const panels = [...this.querySelectorAll('[data-sale-panel]')];
      const results = this.querySelector('[data-sale-results]');
      const grid = this.querySelector('[data-sale-grid]');
      const status = this.querySelector('.featured-collections__loading-status');
      const cache = new Map();
      let currentUrl = new URL(location.href);
      currentUrl.searchParams.delete('preview_theme_id');
      let requestId = 0;
      let controller;
      let loadingTimer;
      let timeout;
      const storageKey = 'halloween_tabs_' + this.dataset.sectionId;
      const setSelected = (buttons, selected) => buttons.forEach(button => {
        const active = button === selected;
        button.classList.toggle('button--primary', active);
        button.classList.toggle('button--secondary', !active);
        button.setAttribute('aria-selected', String(active));
        button.disabled = active;
      });
      const remember = () => {
        try {
          sessionStorage.setItem(storageKey, JSON.stringify({
            top: topButtons.findIndex(button => button.getAttribute('aria-selected') === 'true'),
            sub: panels.map(panel => panel.querySelector('[data-tabs-level="sub"] [aria-selected="true"]')?.dataset.index || '0'),
            scroll: panels.map(panel => panel.querySelector('.filter-values-row-inner')?.scrollLeft || 0)
          }));
        } catch {}
      };
      const prepareUrl = value => {
        const url = new URL(value, location.origin);
        if (url.origin !== location.origin || url.pathname !== root.dataset.collectionUrl) throw new Error('Unexpected collection');
        url.searchParams.set('view', 'halloween2026');
        url.searchParams.set('sort_by', currentUrl.searchParams.get('sort_by') || root.dataset.defaultSort);
        url.searchParams.delete('section_id');
        return url;
      };
      const updateProducts = async value => {
        const url = prepareUrl(value);
        const key = url.toString();
        const id = ++requestId;
        controller?.abort();
        clearTimeout(loadingTimer);
        clearTimeout(timeout);
        controller = new AbortController();
        results.style.setProperty('--ajax-product-placeholder-height', Math.round(grid.getBoundingClientRect().height) + 'px');
        results.classList.add('is-updating-products');
        results.setAttribute('aria-busy', 'true');
        status.textContent = '';
        status.classList.remove('is-visible', 'is-error');
        loadingTimer = setTimeout(() => {
          status.textContent = 'Updating products';
          status.classList.add('is-visible', 'is-loading');
        }, 150);
        timeout = setTimeout(() => controller.abort(), 15000);
        try {
          let html = cache.get(key);
          if (!html) {
            const requestUrl = new URL(url);
            requestUrl.searchParams.set('section_id', root.dataset.sectionId);
            const response = await fetch(requestUrl, { signal: controller.signal });
            if (!response.ok) throw new Error('Products unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const next = doc.querySelector('[data-sale-grid]');
            if (!next || next.dataset.saleCollection !== root.dataset.collectionUrl) throw new Error('Unexpected product response');
            html = next.innerHTML;
            cache.set(key, html);
          }
          if (id !== requestId) return;
          grid.innerHTML = html;
          currentUrl = url;
          history.replaceState(history.state, '', url);
          status.textContent = '';
          status.classList.remove('is-visible');
          remember();
        } catch (error) {
          if (id !== requestId) return;
          status.textContent = 'Unable to update products. Please try again.';
          status.classList.add('is-visible', 'is-error');
          root.querySelectorAll('button[role="tab"][aria-selected="true"]').forEach(button => { button.disabled = false; });
        } finally {
          if (id === requestId) {
            clearTimeout(loadingTimer);
            clearTimeout(timeout);
            status.classList.remove('is-loading');
            results.removeAttribute('aria-busy');
            results.classList.remove('is-updating-products');
            results.style.removeProperty('--ajax-product-placeholder-height');
          }
        }
      };
      const selectTop = button => {
        const index = Number(button.dataset.index);
        setSelected(topButtons, button);
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
        const subButtons = [...panels[index].querySelectorAll('button[role="tab"]')];
        const sub = subButtons.find(item => item.getAttribute('aria-selected') === 'true') || subButtons[0];
        if (sub) setSelected(subButtons, sub);
        initChevronRows(document);
        updateProducts(sub?.dataset.saleUrl || button.dataset.saleUrl);
      };
      listen(root, 'click', event => {
        const button = event.target.closest('button[role="tab"]');
        if (button && root.contains(button)) {
          if (button.closest('[data-tabs-level="top"]')) selectTop(button);
          else {
            setSelected([...button.closest('[role="tablist"]').querySelectorAll('button[role="tab"]')], button);
            updateProducts(button.dataset.saleUrl);
          }
        }
        const page = event.target.closest('[data-sale-pagination] a');
        if (page) { event.preventDefault(); updateProducts(page.href); }
      });
      listen(root, 'keydown', event => {
        const button = event.target.closest('button[role="tab"]');
        if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const buttons = [...button.closest('[role="tablist"]').querySelectorAll('button[role="tab"]')];
        let index = buttons.indexOf(button);
        index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[index].click();
        buttons[index].focus();
      });
      listen(window, 'resize', () => initChevronRows(document));
      listen(root, 'scroll', remember, true);
      listen(window, 'pagehide', remember);
          function updateCentered(inner){
      if (!inner) return;
      if (inner.scrollWidth <= inner.clientWidth + 1) inner.classList.add('is-centered');
      else inner.classList.remove('is-centered');
    }

    function updateChevrons(inner) {
      if (!inner) return;

      var wrapper = inner.closest('.filter-values-row');
      if (!wrapper) return;

      
      if (wrapper.hidden || wrapper.offsetParent === null) return;

      var left = wrapper.querySelector('.filter-scroll-chevron--left');
      var right = wrapper.querySelector('.filter-scroll-chevron--right');
      if (!left || !right) return;

      var maxScrollLeft = inner.scrollWidth - inner.clientWidth;

      updateCentered(inner);

      
      if (inner.scrollWidth <= inner.clientWidth + 1) {
        left.classList.remove('is-visible');
        right.classList.remove('is-visible');
        return;
      }

      
      if (inner.scrollLeft > 2) left.classList.add('is-visible');
      else left.classList.remove('is-visible');

      
      if (inner.scrollLeft < maxScrollLeft - 2) right.classList.add('is-visible');
      else right.classList.remove('is-visible');
    }

    
    function forceUpdateChevronsSoon(inner){
      if (!inner) return;
      requestAnimationFrame(function(){ updateChevrons(inner); });
      setTimeout(function(){ updateChevrons(inner); }, 50);
      setTimeout(function(){ updateChevrons(inner); }, 150);
      setTimeout(function(){ updateChevrons(inner); }, 300);
    }

    function scrollByChevron(inner, dir){
      if (!inner) return;
      if (inner.scrollWidth <= inner.clientWidth + 1) return;

      var amount = Math.round(inner.clientWidth * 0.8) * dir;

      inner.scrollBy({ left: amount, behavior: 'smooth' });

      requestAnimationFrame(function(){ updateChevrons(inner); });
      setTimeout(function(){ updateChevrons(inner); }, 220);
    }

    function initChevronRows(root) {
      var scope = root || document;

      scope.querySelectorAll(rowSelector).forEach(function(inner) {
        if (inner.dataset.subChevronInit === '1') {
          updateChevrons(inner);
          forceUpdateChevronsSoon(inner);
          return;
        }
        inner.dataset.subChevronInit = '1';

        
        updateChevrons(inner);
        forceUpdateChevronsSoon(inner);

        
        var wrapper = inner.closest('.filter-values-row');
        if (wrapper) {
          var left = wrapper.querySelector('.filter-scroll-chevron--left');
          var right = wrapper.querySelector('.filter-scroll-chevron--right');

          if (left && !left.dataset.boundClick) {
            left.dataset.boundClick = '1';
            left.addEventListener('click', function(e){
              e.preventDefault();
              e.stopPropagation();
              if (e.stopImmediatePropagation) e.stopImmediatePropagation();
              scrollByChevron(inner, -1);
            }, true);
          }

          if (right && !right.dataset.boundClick) {
            right.dataset.boundClick = '1';
            right.addEventListener('click', function(e){
              e.preventDefault();
              e.stopPropagation();
              if (e.stopImmediatePropagation) e.stopImmediatePropagation();
              scrollByChevron(inner, 1);
            }, true);
          }
        }

        
        var ticking = false;
        inner.addEventListener('scroll', function() {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function(){
            updateChevrons(inner);
            ticking = false;
          });
        }, { passive: true });

        requestAnimationFrame(function() {
          updateChevrons(inner);
          forceUpdateChevronsSoon(inner);
        });

        setTimeout(function(){
          updateChevrons(inner);
          forceUpdateChevronsSoon(inner);
        }, 80);
      });
    }

    
    var isCoarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    var isHoverNone = window.matchMedia && window.matchMedia('(hover: none)').matches;
    var isTouchDevice = isCoarsePointer || isHoverNone || ('ontouchstart' in window);

    var isDown = false,
        startClientX = 0,
        startClientY = 0,
        startScrollLeft = 0,
        activeInner = null,
        didDrag = false;

    if (!isTouchDevice) {

      
      listen(document, 'click', function(e) {
        if (!didDrag) return;

        var btn = e.target.closest(sectionSel + ' [data-tabs-level="sub"] button[role="tab"]');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        didDrag = false;
      }, true);

      listen(document, 'mousedown', function(e) {
        var inner = e.target.closest(rowSelector);
        if (!inner) return;
        didDrag = false;
        if (inner.scrollWidth <= inner.clientWidth + 1) return;

        isDown = true;
        activeInner = inner;

        startClientX = e.clientX;
        startClientY = e.clientY;
        startScrollLeft = inner.scrollLeft;
      }, true);

      listen(document, 'mousemove', function(e) {
        if (!isDown || !activeInner) return;

        var dx = e.clientX - startClientX;
        var dy = e.clientY - startClientY;

        if (!didDrag && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
          didDrag = true;
          activeInner.classList.add('is-dragging');
          activeInner.classList.add('is-real-drag');
        }

        if (!didDrag) return;

        e.preventDefault();
        activeInner.scrollLeft = startScrollLeft - dx;
        updateChevrons(activeInner);
      }, true);

      function stopDrag() {
        if (activeInner) {
          activeInner.classList.remove('is-dragging');
          activeInner.classList.remove('is-real-drag');
        }
        isDown = false;
        activeInner = null;
      }

      listen(document, 'mouseup', stopDrag);
      listen(document, 'mouseleave', stopDrag);
    }


      initChevronRows(document);
      if (!currentUrl.searchParams.has('page') && ![...currentUrl.searchParams.keys()].some(key => key.startsWith('filter.'))) {
        try {
          const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
          panels.forEach((panel, index) => {
            const buttons = [...panel.querySelectorAll('button[role="tab"]')];
            const selected = buttons.find(button => button.dataset.index === saved.sub?.[index]);
            if (selected) setSelected(buttons, selected);
            const row = panel.querySelector('.filter-values-row-inner');
            if (row) row.scrollLeft = saved.scroll?.[index] || 0;
          });
          if (saved.top > 0 && topButtons[saved.top]) selectTop(topButtons[saved.top]);
        } catch {}
      }
      this.cleanup = () => { controller?.abort(); clearTimeout(loadingTimer); clearTimeout(timeout); };
    }
    disconnectedCallback() {
      this.events?.abort();
      this.cleanup?.();
      this.initialized = false;
    }
  });
}
